import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare let swal: any;
import CryptoJS from 'crypto-js';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MustMatch } from '../helper/must-match.validator';
declare var $: any;
@Component({
  selector: 'app-editusermanagement',
  templateUrl: './editusermanagement.component.html',
  styleUrls: ['./editusermanagement.component.css']
})
export class EditusermanagementComponent implements OnInit {
  returnUrl = "/dashboard/usermanagement";
  getusereditApi: any;
  putusereditApi: any;
  edituserFormValue: any;
  UserId: any;
  getlistApi: any;
  farmuservalue: any;
  getfarmsListData: any;
  getfarmvalue: any;
  editpassword: any;
  editregisterForm: FormGroup;
  submitted = false;
  getuserListData: any = [];
  finalval: any = [];
  constructor(private router: Router, private commonService: CommonService, private formBuilder: FormBuilder) { }

  async ngOnInit() {
    this.getlistApi = "/user_management";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {

        this.getuserListData = res.data.map(function (elem) {
          return {
            email: elem.tnus_email.toLowerCase(),
            userid: elem.tnus_user_code.toLowerCase()
          };
        });
        console.log(this.getuserListData)
      })
    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
        this.getfarmsListData = res.data;
      })

    $('.selectpicker').selectpicker('refresh');
    ///form validation start-------------
    this.editregisterForm = this.formBuilder.group({
      username: ['', Validators.required],
      userid: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
      mobileNumber: ['', [Validators.required, Validators.pattern("[0-9]{10,12}")]]
      // password: ['', Validators.required],
      //confirmPassword: ['',Validators.required],
    }/*{validator: this.passwordMatchValidator}{validator: MustMatch('password', 'confirmPassword')
}*/);
    let UserId = sessionStorage.getItem('userId');
    this.getusereditApi = "/user_management/" + UserId;
    this.putusereditApi = "/user_management/" + UserId;
    (await this.commonService.getApi(this.getusereditApi)).subscribe(
      async (res: any) => {
        this.editregisterForm.patchValue({ username: res.data.tnus_name, userid: res.data.tnus_user_code, email: res.data.tnus_email, mobileNumber: res.data.tnus_contact_no });
        this.farmuservalue = res.data.tnus_role;

        //password decryption start
        this.editpassword = res.data.tnus_password;
        this.getfarmvalue = res.data.tnus_farm_id;
        //password decryption end
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');

          $("#username").val(res.data.tnus_name)
          $("#useremail").val(res.data.tnus_email)
          $("#usercontactval").val(res.data.tnus_contact_no)
          //$("#pswd").val(res.data.tnus_password)
          $("#userid").val(res.data.tnus_user_code)
          $("#userdepartment").val(res.data.tnus_department)
          $("select[name=userrole]").val(res.data.tnus_role)
          $("select[name=farmname]").val(res.data.tnus_farm_id)
          // $("select[name=userid]").val(res.data.tnus_user_code)
          // $("select[name=userdepartment]").val(res.data.tnus_department)
          $("select[name=status]").val(res.data.tnus_status)
          $('.selectpicker').selectpicker('refresh');
          $("#farmname .filter-option").text(res.data.farm_name)
          $("#userrole .filter-option").text(res.data.tnus_role)
          //$("#userid .filter-option").text(res.data.tnus_user_code)
          //$("#userdepartment .filter-option").text(res.data.tnus_department)
          //$("#status .filter-option").text(res.data.tnus_status)
          if (res.data.tnus_status === 1) {
            $("#status  option:selected").text('Active')
          } if (res.data.tnus_status === 0) {
            $("#status  option:selected").text('Inactive')
          }
        }, 800);
      })
    $(document).on('change', '#userrole', function () {
      $('.myFakeClass').dropdown('toggle');
    });
    $(document).on('change', '#farmname', function () {
      $('.myFakeClass1').dropdown('toggle');
    });
    $(document).on('change', '#status', function () {
      $('.myFakeClass2').dropdown('toggle');
    });
  }
  uniquecheckvalidation(e) {
    this.finalval = [];
    var userrecordforcheck = e.target.value.toLowerCase();
    console.log(this.getuserListData)
    let sameemail = this.getuserListData.filter((user) => user.email == userrecordforcheck);
    if (sameemail.length) {
      this.finalval.push(sameemail)
      Swal.fire("Duplicate values", 'User Email already Exist');
    }
  }
  uniquecheckvalidationid(e) {
    this.finalval = [];
    var userrecordforcheck = e.target.value.toLowerCase();
    console.log(userrecordforcheck)
    let sameid = this.getuserListData.filter((user) => user.userid == userrecordforcheck);
    if (sameid.length) {
      this.finalval.push(sameid)
      Swal.fire("Duplicate values", 'User Id already Exist');
    }
  }
  get f() { return this.editregisterForm.controls; }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.editregisterForm.invalid) {
      return;
    }
    // display form values on success
    this.usermanagement()
  }
  async farmuser(e) {
    this.farmuservalue = e.target.value;
    if (this.farmuservalue != ('Farm user')) {
      return;
    }
    else {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      },)
      this.getlistApi = "/farms";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        (res) => {
          this.getfarmsListData = res.data;
        })
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 1000);
    }

  }
  selectfarmuser(e) {
    this.getfarmvalue = e.target.value
    console.log(this.getfarmvalue);
  }
  async usermanagement() {
    if (this.finalval.length) {
      Swal.fire("Duplicate values", 'Userid or Email already Exist');
    } else {
      this.edituserFormValue = {
        "role": $('#userrole').val(),
        "name": $('#username').val(),
        "email": $('#useremail').val(),
        "user_code": $('#userid').val(),
        "contact_no": $('#usercontact').val(),
        "department": $('#userdepartment').val(),
        "status": $('#status').val(),
        "password": this.editpassword,
        "farm_id": this.getfarmvalue
      };
      (await this.commonService.putApi(this.putusereditApi, this.edituserFormValue)).subscribe(
        data => {
          alert("Data edited Successfully");
        });

      setTimeout(
        (): void => {

          this.router.navigate([this.returnUrl]);

        },
        500
      );
    }
  }
  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
